(function (app) {

    app.provider("longTermCareAccountApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.get = function (longTermCareAccountId) {
                            return crmApiGateway.get("/LongTermCareAccounts/" + longTermCareAccountId);
                        }

                        service.getLongTermCareAccounts = function () {
                            return crmApiGateway.getArray("/LongTermCareAccounts");
                        }

                        service.getCaseLongTermCareAccounts = function (caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/LongTermCareAccounts");
                        }

                        service.getCaseLongTermCareAccountsComplete = function (caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/LongTermCareAccounts/Complete");
                        }

                        service.update = function (longTermCareAccountId, longTermCareAccount) {
                            return crmApiGateway.put("/LongTermCareAccounts/" + longTermCareAccountId, longTermCareAccount);
                        }

                        service.create = function (longTermCareAccount) {
                            return crmApiGateway.post("/LongTermCareAccounts", longTermCareAccount);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line